// import { LectaPaymentServiceSDK } from '@lecta/payment-service-sdk'
// "@lecta/payment-service-sdk": "https://bitbucket.org/thesis-agency/ps_js_sdk.git",
import { LectaPaymentServiceSDK } from './lib'
import { PAYMENT_SERVICE_TOKEN } from '@/config'

const ps = new LectaPaymentServiceSDK({ userId: null, serviceToken: PAYMENT_SERVICE_TOKEN })

export default ps
